import metricsApi from '@ibkr/clientportal.common/src/api/metricsApi'
import errorApi from '@ibkr/clientportal.common/src/api/errorApi'
import { Settings } from '@ibkr/clientportal.common/src/js/settings'

/**
 * get an instance with Metrics.instance()
 * add event data with metrics.register({
 *  'type': 'account-picker-time',
 *  'source': 'DevPicker',
 *  'timestamp': 123456789,
 *  'value': 1234,
 *  ....
 * });
 */

const debug = process.env.DEBUG_USAGE || false;
const LOCAL_STORAGE_METRICS_KEY = 'cp.metrics';
const LOCAL_STORAGE_DAILY_METRICS_KEY = 'cp.metrics.daily';
let metrics = null;
let log = false;
const POLLING_INTERVAL = 15000;
let startTime = {}; // keep track of timers, key => val.

// list of allowed metrics sources. A metric is pushed only if its source is declared here
const ALLOWED_SOURCES = new Set(
    [
        'iserver', // CLNTPORTAL-2979
        'REST'
    ]
);

export default class Metrics {

    // private use only
    constructor() {
        setInterval(() => this.publishMetrics(), POLLING_INTERVAL);
    }

    // private use only
    store(obj) {
        Settings && Settings.get(LOCAL_STORAGE_METRICS_KEY, []).then(metrics => {
            if (obj.source && ALLOWED_SOURCES.has(obj.source)) {
                Settings.store(LOCAL_STORAGE_METRICS_KEY, [ ...metrics, ...[obj] ]);
                log && console.debug(`-metrics- Stored to LocalStorage: ${JSON.stringify(obj)}`);
            }
        }).catch(err => {
            log && console.debug(`-metrics- Failed to store metrics to LocalStorage: ${err}`);
        });
    }

    // private use only
    publishMetrics() {
        Settings && Settings.get(LOCAL_STORAGE_METRICS_KEY).then(metrics => {
            if (metrics.length) {
                metricsApi.report(metrics);
                Settings.store(LOCAL_STORAGE_METRICS_KEY, []); // remove metrics from local storage
                log && console.debug(`-metrics- published ${metrics.length}`);
            }
        }).catch(err => {
            log && console.debug(`-metrics- Failed to load metrics from LocalStorage: ${err}`);
        });
    }

    /*********************************

             Public Functions

     ********************************/

    /**
     * Report a metric. Each metric contains at least a source, type and a value.
     */
    register(data) {
        if (!data) return;
        this.store(data);
    }

    /**
     * Used to report metrics which should be reported maximum once every 24 hours
     */
    registerDaily(data) {
        /*
         * These metrics are currently disabled. Only Metrics.store() is supported for now
         * Refer CLNTPORTAL-1065
         */
        /*
        if (!data || !data.type) return;
        Settings && Settings.get(LOCAL_STORAGE_DAILY_METRICS_KEY, {}).then(metrics => {
            if (metrics[data.type]) {
                // check if stored timestamp is not older than 24 hours
                // if its not older than 24 hours, do no report metric
                if ($date.local().diffDays(metrics[data.type]) < 1) {
                    return;
                }
            }
            metrics[data.type] = +$date.local();
            Settings.store(LOCAL_STORAGE_DAILY_METRICS_KEY, metrics);
            this.store(data);
            log && console.debug(`-metrics- Stored to LocalStorage: ${JSON.stringify(data)}`);
        }).catch(err => {
            log && console.debug(`-metrics- Failed to store metrics ${data.type} to LocalStorage: ${err}`);
        });
        */
    }

    registerEvent(source, type, value) {
        if (!source || !value) {
            console.warn('missing source or value', source, value);
            return;
        }
        const obj = {
            'source': source,
            'type': type,
            'value': value
        };
        this.store(obj);
    }
    /**
     * Utility function specifically to register a click event
     */
    registerClickEvent(source, value) {
        this.registerEvent(source, 'click-event', value);
    }

    static startTimer(type) {
        startTime[type] = +$date.local();
    }

    static endTimer(source, type) {
        const st = startTime[type];
        Metrics.instance().register({
            'type': type,
            'source': source,
            'timestamp': st,
            'value-int': $date.local() - st
        });
    }

    /**
     * used to report an error to backend
     */
    static error(message) {
        metricsApi.error(message);
        log && console.debug(`-metrics- on error, ${message}`);
    }

    static toggleLogging() {
        log = !log;
        console.debug(`-metrics- Logging:${log}`);
    }

    static instance() {
        try {
            if (metrics == null) {
                metrics = new Metrics();
            }
            return metrics;
        } catch (e) {
            errorApi.report('Failed to create Metrics instance: ' + e);
        }
    }

}
